module.exports = __webpack_public_path__ + "media/n01.1584b88b.mp4";